import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SharedModule } from "./shared/shared.module";
import { MaterialModule } from '@shared/material-ui.module';
import { Theme, ThemeService } from '@shared/services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SharedModule, MaterialModule],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App {
  protected readonly title = signal('knt-school-erp');

  themes: Theme[] = [];

  constructor(private themeService: ThemeService) {
    this.themes = this.themeService.getThemes();
  }

  changeTheme(themeId: string) {
    this.themeService.setTheme(themeId);
  }

  toggleTheme() {
    this.themeService.toggleNextTheme();
  }
}
